import React__default from 'react';
import '../../dropdown/dropdown-floating-label.component.js';
import { DropdownOption } from '../../dropdown/dropdown-option.component.js';
import '../../dropdown/dropdown-with-floating-label.component.js';
import '../../dropdown/dropdown.component.js';
import '@reach/listbox';
import '../../listbox/basic-listbox.component.js';
import '../../listbox/listbox-button-with-label.component.js';
import '../../listbox/listbox-button.component.js';
import '../../listbox/listbox-group-label.component.js';
import '../../listbox/listbox-group.component.js';
import '../../listbox/listbox-list.component.js';
import { ListboxOption } from '../../listbox/listbox-option.component.js';
import '../../listbox/listbox-popover.component.js';
import '../../listbox/listbox.component.js';
import { useSelectContext } from './select.context.js';
function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
const Option = props => {
  const {
    variant
  } = useSelectContext();
  if (variant === 'listbox') {
    return /*#__PURE__*/React__default.createElement(ListboxOption, _extends({}, props));
  }
  return /*#__PURE__*/React__default.createElement(DropdownOption, _extends({}, props));
};
Option.displayName = 'Option';
export { Option };